<template>
  <div>
    <vx-card class="w-full mb-6">
      <vs-table ref="questionTable" stripe class="vs-con-loading__container" single @selected="handleSelectedQuestion" pagination :max-items="itemsPerPage" search :data="questions" v-scroll-to="'#questionInfoCard'">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
          <div class="flex flex-wrap-reverse items-center">
            <!-- ADD NEW -->
            <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="showDetailsCard" >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
              <span class="ml-2 text-base text-primary">Add New</span>
            </div>
          </div>

          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
              <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ questions.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : questions.length }} of {{ questions.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage=10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=25">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=50">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=100">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th sort-key="text">Question</vs-th>
          <vs-th sort-key="moduleId">{{$getSiteId() == 26 ? 'Selected LP': 'Selected Module'}}</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="question" :key="indextr" v-for="(question, indextr) in data">

            <vs-td :data="data[indextr].text">
              {{ question.text }}
            </vs-td>

            <vs-td :data="data[indextr].moduleId">
              <div v-if="question.moduleId">
                {{moduleList.filter(x=>x.value == question.moduleId)[0].label}}
              </div>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <vx-card id="questionInfoCard" ref="questionInfo" class="mb-6" :title="questionCardTitle" v-show="!isInfoHidden">
      <div class="vx-row pb-3">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label>Text</label>
          <vs-textarea autocomplete="off" onClick="this.select();" class="w-full" v-model="formData.text" />
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <label>{{$getSiteId() == 26  ? 'LP Name' : 'Module Name'}}<small>(optional)</small></label>
          <v-select
              ref="moduleDropdown"
              class="w-full style-chooser"
              placeholder="Search / Select LP"
              :options="moduleList"
              v-model="moduleDropdown"
          >
          </v-select>
        </div>
      </div>
      <div class="vx-row mb-3">
        <div class="vx-col w-full">
          <span v-if="moduleDropdown">{{'This question will need to be answered for '}}<strong>{{moduleDropdown.label}}</strong></span>
          <span v-else>This question will need to be answered <strong>for all module logbooks</strong></span>
        </div>
      </div>
      <div class="vx-row">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" :disabled="isDisabled" @click.prevent="saveEditQuestion" ref="saveEditButton">Save</vs-button>
          <vs-button color="danger"  class="mr-5 mb-2 vs-con-loading__container" @click.prevent="deleteQuestion" ref="deleteButton">Delete</vs-button>
          <vs-button color="warning" type="border" class="mb-2" v-scroll-to="'#questionInfoCard'" @click="cancelAdd">Cancel</vs-button>
        </div>
      </div>
    </vx-card>

  </div>
</template>

<script>
import vSelect from 'vue-select'

  export default {
    components: {
      'v-select': vSelect
    },
    data() {
      return {
        loadingColor:'#fff',
        selected: [],
        itemsPerPage: 10,
        isMounted: false,
        isInfoHidden: true,
        questions: [],
        formData: {
          id: 0,
          text: "",
          moduleId:0,
        },
        mode: "",
        questionCardTitle: "",
        counterDanger: false,
        moduleDropdown:null,
        moduleList: []
      }
    },
    computed: {
      currentPage() {
        if (this.isMounted) {
          return this.$refs.questionTable.currentx;
        }
        return 0;
      },
      isDisabled: function() {
        return !(this.formData.text);
      }
    },
    methods: {
      initValues() {
        this.formData.id = 0;
        this.formData.text = "";
        this.formData.moduleId = 0;
        this.mode = "";
        this.isInfoHidden = true;
        this.errors.clear();
      },
      cancelAdd() {
        this.initValues();
        this.isInfoHidden = true;
      },
      saveData() {
        this.initValues();
        this.loadData();
        this.$vs.loading.close(this.$refs.saveEditButton.$el);
      },
      loadData() {
        const self = this;
        self.showLoadingOnElement("questionTable", 1, "corners");

        var onSuccess = function (response) {
          self.questions = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.questionTable.$el);
        };
        self.$ajaxGet(self, "WitnessTestimonyQuestion/List", onSuccess, onFinally);
      },
      showDetailsCard(){
        var self = this;
        self.errors.clear();
        self.initValues();
        self.isInfoHidden = false;
        self.mode = "Add New";
        self.questionCardTitle = "Add Question";
      },
      handleSelectedQuestion(question) {
        var self = this;
        self.isInfoHidden = false;
        self.mode = "Update";
        self.questionCardTitle = "Edit Question";
        self.formData.id = question.id;
        self.formData.text = question.text;
        self.formData.moduleId = question.moduleId;
        self.moduleDropdown = self.moduleList.filter(x=>x.value == question.moduleId)[0];
      },
      saveEditQuestion() {
        var self = this;
        self.$validator.validateAll().then(result => {
          if (result) {
            self.showLoadingOnElement("saveEditButton", 0.45, "material");
            if(self.moduleDropdown){
              self.formData.moduleId = self.moduleDropdown.value;
            }
            else{
              self.formData.moduleId = null
            }
            var onSuccess = response => {
              self.formData.id = response.data;
              self.saveData();
              if(self.mode != "Add New"){
                self.isInfoHidden = true;
                self.initValues();
              }else
                self.defaultButtonsHidden = true;

              self.$vs.notify({
                title:'Information',
                color: "success",
                text: "Question Saved",
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-save'
              });
            };
            var onFinally = function () {
              self.$vs.loading.close(self.$refs.saveEditButton.$el);
            };
            self.$ajaxPost(self, "WitnessTestimonyQuestion/AddEdit", self.formData, onSuccess, onFinally);
          } else {
            self.$vs.notify({
              title:'Attention',
              color: "warning",
              text: self.$validator.errors.items[0].msg,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
          }
        });
      },
      deleteQuestion() {
        var self = this;
        self.showLoadingOnElement("deleteButton", 0.45, "material");

        var onSuccess = response => {
          self.saveData();
          self.initValues();
          self.errors.clear();
          self.isInfoHidden = true;
          self.scrollToNavbar();
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Question Deleted",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.deleteButton.$el);
        };
        self.formData.id = parseInt(self.formData.id);
        self.$ajaxDelete(self, "WitnessTestimonyQuestion/Delete/" + self.formData.id, onSuccess, onFinally);
      },
      showLoadingOnElement(element, scale, type){
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
       getModules(){
        var self = this;

        var onSuccess = response=>{
          var tempModules = response.data.map(x=>{
            return{label: x.text, value: x.value}
          });

          self.moduleList = tempModules.sort((a, b) =>
            a.label > b.label ? 1 : -1
          );

          self.moduleList = Array.from(new Set(self.moduleList.map(x => x.value)))
            .map(value => {return{label: self.moduleList.find(x => x.value == value).label,
                                  value: value}});
        };
        self.$ajaxGet(self, "Module/GetAllModulesWithCourseName", onSuccess);
      },
    },
    mounted() {
      var self = this;
      self.getModules();
      self.loadData();
    },
  }

</script>